import React, { useState } from "react";
import { Button, Input, Alert } from "antd";
import { useTranslation } from "react-i18next";
import styles from "./alertLimitUpgrade.module.scss";

/**
 * Visual card checkout shown when Stripe session cannot be created.
 * Card data is never sent to Pivony — retry delegates to Stripe once configured.
 */
const AlertCardCheckoutFallback = ({ onRetry, onCancel, notice }) => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState("");

  const handlePay = async () => {
    setSubmitting(true);
    setLocalError("");
    const ok = await onRetry();
    setSubmitting(false);
    if (!ok) {
      setLocalError(
        t(
          "alerts_page.upgrade_stripe_unavailable",
          "Online ödeme henüz aktif değil. Lütfen support@pivony.com ile iletişime geçin.",
        ),
      );
    }
  };

  return (
    <div className={styles.fallbackCheckout}>
      {notice && (
        <Alert type="warning" message={notice} showIcon className={styles.fallbackNotice} />
      )}
      {localError && (
        <Alert type="error" message={localError} showIcon className={styles.fallbackNotice} />
      )}

      <div className={styles.fallbackMethods}>
        <div className={`${styles.fallbackMethod} ${styles.fallbackMethodActive}`}>
          <span>{t("alerts_page.upgrade_card_method", "Banka / Kredi Kartı")}</span>
        </div>
      </div>

      <label className={styles.fallbackLabel}>
        {t("alerts_page.upgrade_card_number", "Kart numarası")}
        <Input
          placeholder="1234 1234 1234 1234"
          autoComplete="cc-number"
          inputMode="numeric"
          className={styles.fallbackInput}
        />
      </label>

      <div className={styles.fallbackRow}>
        <label className={styles.fallbackLabel}>
          {t("alerts_page.upgrade_card_expiry", "AA/YY")}
          <Input placeholder="MM/YY" autoComplete="cc-exp" className={styles.fallbackInput} />
        </label>
        <label className={styles.fallbackLabel}>
          {t("alerts_page.upgrade_card_cvc", "CVC")}
          <Input placeholder="CVC" autoComplete="cc-csc" className={styles.fallbackInput} />
        </label>
      </div>

      <label className={styles.fallbackLabel}>
        {t("alerts_page.upgrade_card_name", "Kart üzerindeki isim")}
        <Input placeholder="Ad Soyad" autoComplete="cc-name" className={styles.fallbackInput} />
      </label>

      <p className={styles.fallbackHint}>
        {t(
          "alerts_page.upgrade_card_hint",
          "Ödeme Stripe altyapısı ile güvenli şekilde işlenir. Kart bilgisi Pivony sunucularında saklanmaz.",
        )}
      </p>

      <div className={styles.fallbackActions}>
        <Button onClick={onCancel}>{t("alerts_page.upgrade_cancel", "Vazgeç")}</Button>
        <Button type="primary" loading={submitting} onClick={handlePay}>
          {t("alerts_page.upgrade_pay", "Öde")}
        </Button>
      </div>
    </div>
  );
};

export default AlertCardCheckoutFallback;
